// extracted by mini-css-extract-plugin
export default {"root":"PreviewFileModal_root__ABUtx","body":"PreviewFileModal_body__NSh4W","container":"PreviewFileModal_container__LVGh9","main":"PreviewFileModal_main__x-9Bq"};